import { render, staticRenderFns } from "./PolitiqueDeConfidentialite.vue?vue&type=template&id=67842756&scoped=true&"
var script = {}
import style0 from "./PolitiqueDeConfidentialite.vue?vue&type=style&index=0&id=67842756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67842756",
  null
  
)

export default component.exports